import { useCallback, useEffect, useMemo, useState } from "react";
import { Toast, ToastBody } from "reactstrap";
import "styles/global.scss";
import "styles/anim.scss";

/**
 * Toast for index page
 * @param {*} message 
 * @param {*} useTimer 
 * @returns 
 */
const useGlobalToast = (message = "", useTimer = 0) => {
  const [isToastOpen, setIsToastOpen] = useState(false);

  const closeToast = useCallback(() => {
    setIsToastOpen(false);
  }, [setIsToastOpen]);

  /* const toggleToast = useCallback(() => {
    setIsToastOpen(!isToastOpen);
  }, [isToastOpen, setIsToastOpen]) */

  const showToast = useCallback(() => {
    setIsToastOpen(true);

    if (useTimer) {
      const closeTimer = setTimeout(() => {
        setIsToastOpen(false);
        clearTimeout(closeTimer);
      }, useTimer);

      return () => {
        clearTimeout(closeTimer);
      };
    }
  }, [setIsToastOpen, useTimer]);

  const toastComponent = useMemo(() => {
    const toastComponentDefinition = ({ children, ...props }) => {
      return (
        <Toast
          isOpen={isToastOpen}
          delay={useTimer}
          autohide="true"
          className={`common-toast align-items-center text-white bg-primary border-0`}
          role="alert"
        >
          <div className="d-flex">
            {/* <ToastHeader toggle={toggleToast}>
              알림
            </ToastHeader> */}
            <ToastBody>{message}</ToastBody>
            <button
              onClick={() => closeToast()}
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
            />
          </div>
        </Toast>
      );
    };
    return toastComponentDefinition;
  }, [isToastOpen, useTimer, message, closeToast]);

  useEffect(() => {});

  return { isToastOpen, showToast, closeToast, NoticeToast: toastComponent };
};

/**
 * Simple Toast
 * @returns 
 */
export const useSimpleToast = () => {
  const [isToastOpen, setIsToastOpen] = useState(false);

  const closeToast = useCallback(() => {
    setIsToastOpen(false);
  }, [setIsToastOpen]);

  const showToast = useCallback((useTimer = 0) => {
    setIsToastOpen(true);
    if (useTimer) {
      const closeTimer = setTimeout(() => {
        setIsToastOpen(false);
      }, useTimer);

      return () => {
        clearTimeout(closeTimer);
      };
    }
  }, [setIsToastOpen]);

  const toastComponent = useMemo(() => {
    const toastComponentDefinition = ({ message = "", ...props }) => {
      return (
        <Toast
          isOpen={isToastOpen}
          className={`common-toast align-items-center text-white bg-primary border-0`}
          role="alert"
        >
          <div className="d-flex">
            {/* <ToastHeader toggle={toggleToast}>
              알림
            </ToastHeader> */}
            <ToastBody>{message}</ToastBody>
            <button
              onClick={() => closeToast()}
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
            />
          </div>
        </Toast>
      );
    };
    return toastComponentDefinition;
  }, [isToastOpen, closeToast]);

  return { isToastOpen, showToast, closeToast, ToastComponent: toastComponent };
}

export default useGlobalToast;
